import {ɵ_sanitizeHtml as sanitizeHtml} from "@angular/core";
import {CDN_COOKIEYES, pathSpecificScriptOrigins} from "./global-headers";

// Returning null from the default policy rejects the value (TypeError + CSP violation report),
// but @types/trusted-types only allows string return values
const REJECT = null as unknown as string;

// Angular's sanitizer strips <style> elements and data-* attributes, which the CookieYes banner relies on,
// so HTML assigned directly by CookieYes scripts is trusted as is
function isCookieYesCaller(policyStack: string | undefined) {
  // The stack must be captured inside the policy: frame 0 is the policy itself, frame 1 is the script assigning the HTML.
  // Covers both Chromium ("at fn (url:1:2)") and Firefox/Safari ("fn@url:1:2") stack formats.
  // If the stack is missing or its format changes, this returns false and the HTML gets sanitized
  const frameUrls = (policyStack ?? "")
    .split("\n")
    .map(frame => frame.match(/(https?:\/\/\S+?):\d+:\d+\)?$/)?.[1])
    .filter(url => url !== undefined);
  try {
    return frameUrls.length > 1 && new URL(frameUrls[1]).origin === CDN_COOKIEYES;
  } catch (e) {
    return false;
  }
}

if (typeof window !== "undefined" && window.trustedTypes?.createPolicy) {
  window.trustedTypes.createPolicy("default", {
    createHTML: (html: string) => isCookieYesCaller(new Error().stack) ? html : sanitizeHtml(document, html).toString(),
    createScriptURL: (url: string) => {
      try {
        const absoluteUrl = new URL(url, window.location.origin);
        const allowedScriptOrigins = pathSpecificScriptOrigins(location.pathname);
        return allowedScriptOrigins.includes(absoluteUrl.origin) ? url : REJECT
      } catch (e) {
        return REJECT;
      }
    }
  });
}
